import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';

import { View } from 'backbone';

import formatTemplate from 'properties/advanced/sections.ejs';


class SectionsView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change #section' : 'updateSelectAttributes'
        };

        // Add needed property
        if (!this.model.get('section')) {
            this.model.set('section', 'complete', {silent: true});
        }

        this.listenTo(this.model, 'change', this.updateForm);
        return this;
    }



    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        this.model.set( propName, propVal );
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if(this.model.get('section')) {
            $('#section').find("option[value='"+this.model.get('section')+"']").attr('selected', true);
        }

        this.delegateEvents();
        return this;
    }
    updateForm() {
        //set selected index to model value
        if(this.model.get('section')) {
            $('#section').find("option[value='"+this.model.get('section')+"']").attr('selected', true);
        }
    }

}

export default SectionsView;
